import { render } from "./IncidentsManagement.vue?vue&type=template&id=f8b94394&scoped=true"
import script from "./IncidentsManagement.vue?vue&type=script&lang=js"
export * from "./IncidentsManagement.vue?vue&type=script&lang=js"

import "./IncidentsManagement.vue?vue&type=style&index=0&id=f8b94394&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8b94394"]])

export default __exports__